import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../lib/msalConfig';

export function SignIn() {
  const { instance } = useMsal();

  const handleSignIn = () => {
    void instance.loginRedirect(loginRequest);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <h1 style={styles.title}>Irrigation Inspector</h1>
        <p style={styles.subtitle}>Sign in with your work account to continue.</p>
        <button type="button" style={styles.button} onClick={handleSignIn}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f4f6',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: '#fff',
    padding: '2.5rem',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
    width: '24rem',
    textAlign: 'center',
  },
  title: { fontSize: '1.5rem', fontWeight: 600, margin: '0 0 0.5rem' },
  subtitle: { fontSize: '0.95rem', color: '#4b5563', margin: '0 0 1.75rem' },
  button: {
    width: '100%',
    padding: '0.75rem 1rem',
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
};
